/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Build_Clear_ConfirmInputs */

const en_us2_plan_build_clear_confirm = /** @type {(inputs: Plan_Build_Clear_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Delete all`)
};

const pt_br2_plan_build_clear_confirm = /** @type {(inputs: Plan_Build_Clear_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apagar tudo`)
};

const es_419_plan_build_clear_confirm = /** @type {(inputs: Plan_Build_Clear_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Borrar todo`)
};

const pt_pt2_plan_build_clear_confirm = /** @type {(inputs: Plan_Build_Clear_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apagar tudo`)
};

const fr_fr2_plan_build_clear_confirm = /** @type {(inputs: Plan_Build_Clear_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tout supprimer`)
};

const de_de2_plan_build_clear_confirm = /** @type {(inputs: Plan_Build_Clear_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alles löschen`)
};

const it_it2_plan_build_clear_confirm = /** @type {(inputs: Plan_Build_Clear_ConfirmInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elimina tutto`)
};

/**
* | output |
* | --- |
* | "Delete all" |
*
* @param {Plan_Build_Clear_ConfirmInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const plan_build_clear_confirm = /** @type {((inputs?: Plan_Build_Clear_ConfirmInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Build_Clear_ConfirmInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_plan_build_clear_confirm(inputs)
	if (locale === "es-419") return es_419_plan_build_clear_confirm(inputs)
	if (locale === "pt-PT") return pt_pt2_plan_build_clear_confirm(inputs)
	if (locale === "fr-FR") return fr_fr2_plan_build_clear_confirm(inputs)
	if (locale === "de-DE") return de_de2_plan_build_clear_confirm(inputs)
	if (locale === "it-IT") return it_it2_plan_build_clear_confirm(inputs)
	return en_us2_plan_build_clear_confirm(inputs)
});
export { plan_build_clear_confirm as "plan-build.clear_confirm" }